import { FutureOnlineItemController } from "./future-item.controller";
import "./item-bids-dialog/item-bids-trigger.component";

angular
    .module("thor.online-containers.edit.future-item.component", [
        "thor.online-containers.edit.item-bids-trigger.component"
    ])
    .component("futureOnlineItem", {
        bindings: {
            getTranslationStatus: "&",
            item: "<",
            isItemEdited: "<",
            isMaxItemsReached: "<",
            containerGlobalStatus: "<?",
            readOnly: "<",
            saleCurrency: "<",
            saleStarted: "<",
            saleWithoutShipping: "<",
            sourceLang: "<",
            selectedLang: "<"
        },
        controller: FutureOnlineItemController,
        controllerAs: "futureOnlineItemCtrl",
        template: require("./future-item.html")
    });
